import { css } from '@emotion/core';
import { stretchWidth } from '../../constants/HelperStyles';

export const loadingMessageStyle = css`
    ${stretchWidth}
`;
